import React, { useState } from "react";
import { useScrollPosition } from "../hooks/useScrollPosition";
import useResizeObserver from "../hooks/useResizeObserver";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { NavLink } from "./home/migration";

const Navigation = React.forwardRef(
  (
    { firstName, about, experience, leadership, repos, skills, awards },
    ref,
  ) => {
    // const { showBlog, FirstName } = config;
    const [isTop, setIsTop] = useState(true);
    const [scrollPosition, setScrollPosition] = useState(0);
    const navbarMenuRef = React.useRef();
    const navbarDimensions = useResizeObserver(navbarMenuRef);
    const navBottom = navbarDimensions ? navbarDimensions.bottom : 0;
    useScrollPosition(
      ({ prevPos, currPos }) => {
        if (!navbarDimensions) return;
        currPos.y + ref.current.offsetTop - navbarDimensions.bottom > 5
          ? setIsTop(true)
          : setIsTop(false);
        setScrollPosition(currPos.y);
      },
      [navBottom],
    );

    React.useEffect(() => {
      if (!navbarDimensions) return;
      navBottom - scrollPosition >= ref.current.offsetTop
        ? setIsTop(false)
        : setIsTop(true);
    }, [navBottom, navbarDimensions, ref, scrollPosition]);

    return (
      <Navbar
        ref={navbarMenuRef}
        className={`px-3 fixed-top  ${
          !isTop ? "navbar-white" : "navbar-transparent"
        }`}
        expand="lg"
      >
        <Navbar.Brand
          className="navbar-brand"
          href={process.env.PUBLIC_URL + "/#home"}
        >
          {`<${firstName} />`}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="toggler" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="navbar-nav mr-auto">
            {/* {
            <NavLink className="nav-item lead">
              <Link to={process.env.PUBLIC_URL + "/blog"}>Blog</Link>
            </NavLink>
          } */}

            {about.show && (
              <NavLink
                className="nav-item lead"
                href={process.env.PUBLIC_URL + "/#aboutme"}
              >
                About
              </NavLink>
            )}

            <NavLink
              className="nav-item lead"
              href={about.resume}
              target="_blank"
              rel="noreferrer noopener"
            >
              Resume
            </NavLink>

            {experience.show && (
              <NavLink
                className="nav-item lead"
                href={process.env.PUBLIC_URL + "/#experience"}
              >
                Experience
              </NavLink>
            )}

            {leadership.show && (
              <NavLink
                className="nav-item lead"
                href={process.env.PUBLIC_URL + "/#leadership"}
              >
                Leadership
              </NavLink>
            )}

            {repos.show && (
              <NavLink href={process.env.PUBLIC_URL + "/#projects"}>
                Projects
              </NavLink>
            )}
            {skills.show && (
              <NavLink
                className="nav-item lead"
                href={process.env.PUBLIC_URL + "/#skills"}
              >
                Skills
              </NavLink>
            )}
            {awards.show && (
              <NavLink href={process.env.PUBLIC_URL + "/#awards"}>
                Awards
              </NavLink>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  },
);

export default Navigation;
